export const funnelReviewsFilterStarterPack = [
	'funnelReviews.review1',
	'funnelReviews.review2',
	'funnelReviews.review3',
];
